"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLinkRef = resolveLinkRef;
/**
 * Pure resolver from a `LinkRef` to a concrete href. Shared so the storefront
 * renderer and the editor preview compute identical URLs. An unknown page id
 * resolves to `#` (safe no-op) rather than a broken route.
 */
function resolveLinkRef(link, ctx) {
    switch (link.kind) {
        case 'page': {
            const slug = ctx.pageSlugById[link.pageId];
            return { href: slug ? `/${slug}` : '#', external: false, newTab: false };
        }
        case 'category':
            return { href: `/category/${link.categoryId}`, external: false, newTab: false };
        case 'builtin':
            return { href: link.route === 'home' ? '/' : `/${link.route}`, external: false, newTab: false };
        case 'external':
            return { href: link.url, external: true, newTab: !!link.newTab };
    }
}
//# sourceMappingURL=link-resolver.js.map